import { LEGACY_CONSENT_KEY } from '../constants';
import { COOKIE_CONSENT_VERSION, type CookieConsentRecord } from './types';
import { DEFAULT_COOKIE_PREFERENCES, normalizePreferences } from './cookieCategories';

export const CONSENT_STORAGE_KEY = 'luminary_cookie_preferences';

function parseRecord(raw: string): CookieConsentRecord | null {
  try {
    const parsed = JSON.parse(raw) as CookieConsentRecord;
    if (parsed.version !== COOKIE_CONSENT_VERSION || !parsed.preferences) return null;
    return {
      version: COOKIE_CONSENT_VERSION,
      updatedAt: parsed.updatedAt,
      preferences: normalizePreferences(parsed.preferences),
    };
  } catch {
    return null;
  }
}

function migrateLegacyConsent(): CookieConsentRecord | null {
  if (typeof localStorage === 'undefined') return null;
  const legacy = localStorage.getItem(LEGACY_CONSENT_KEY);
  if (legacy === 'analytics') {
    return {
      version: COOKIE_CONSENT_VERSION,
      updatedAt: new Date().toISOString(),
      preferences: { essential: true, functional: true, analytics: true },
    };
  }
  if (legacy === 'essential') {
    return {
      version: COOKIE_CONSENT_VERSION,
      updatedAt: new Date().toISOString(),
      preferences: { ...DEFAULT_COOKIE_PREFERENCES },
    };
  }
  return null;
}

export function readConsentRecord(): CookieConsentRecord | null {
  if (typeof localStorage === 'undefined') return null;

  const raw = localStorage.getItem(CONSENT_STORAGE_KEY);
  if (raw) {
    const record = parseRecord(raw);
    if (record) return record;
  }

  return migrateLegacyConsent();
}

export function writeConsentRecord(record: CookieConsentRecord): void {
  if (typeof localStorage === 'undefined') return;
  localStorage.setItem(CONSENT_STORAGE_KEY, JSON.stringify(record));
  localStorage.setItem(
    LEGACY_CONSENT_KEY,
    record.preferences.analytics ? 'analytics' : 'essential',
  );
}

export function clearConsentRecord(): void {
  if (typeof localStorage === 'undefined') return;
  localStorage.removeItem(CONSENT_STORAGE_KEY);
  localStorage.removeItem(LEGACY_CONSENT_KEY);
}
